import variants from "@/assets/contact.webp?w=480;720;960;1400&format=webp&as=meta";
import { responsiveImage } from "@/lib/responsiveImage";

export const contactPhoto = responsiveImage(variants);
export const contactPhotoAlt =
  "Somo keypad and USB outlet on a velvet headboard beneath a glass pendant light";
